import React from 'react';
import PropTypes from 'prop-types';

export default function MailIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 12" {...rest}>
      <path
        fill={color}
        d="M7.06059487,7.10769231 C7.24521026,7.29230769 7.52213333,7.29230769 7.70674872,7.10769231 L14.6605949,0.646153846 C14.7836718,0.4 14.7529026,0 14.2605949,0 L0.506748717,0.0307692308 C0.137517948,0.0307692308 -0.17017436,0.369230769 0.106748717,0.676923077 L7.06059487,7.10769231 L7.06059487,7.10769231 Z M14.7836718,3.16923077 C14.7836718,2.86153846 14.414441,2.67692308 14.1682872,2.89230769 L8.72213333,7.90769231 C8.35290256,8.24615385 7.8913641,8.43076923 7.39905641,8.43076923 C6.90674872,8.43076923 6.44521026,8.24615385 6.07597949,7.93846154 L0.660594871,2.89230769 C0.414441024,2.67692308 0.0452102552,2.83076923 0.0452102552,3.16923077 C0.0144410245,3.07692308 0.0144410245,10.1538462 0.0144410245,10.1538462 C0.0144410245,10.8307692 0.568287178,11.3846154 1.24521026,11.3846154 L13.5529026,11.3846154 C14.2298256,11.3846154 14.7836718,10.8307692 14.7836718,10.1538462 L14.7836718,3.16923077 Z"
      />
    </svg>
  );
}

MailIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

MailIcon.defaultProps = {
  size: 15,
  color: '#000',
};
